var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNcbSolacDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 478.26 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,.81h22.35l22.15,44.5h0V.81h16.09v65.5h-21.95L15.75,21.54h0l.61,44.77H0V.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m127.51,65.17c-6.34,1.74-12.88,2.63-19.46,2.63-17.44,0-37.63-8.82-37.63-33.66C70.42,11.31,86.37,0,107.98,0c6.59.17,13.13,1.3,19.39,3.37l-1.41,14.14c-5.18-2.99-11.05-4.57-17.03-4.58-11.56.37-20.64,10.05-20.26,21.61.37,11.56,10.05,20.64,21.61,20.26h0c5.62-.14,11.16-1.3,16.36-3.43l.88,13.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m135.05.81h30.09c12.19,0,21.27,5.39,21.27,16.63.45,7.19-4.36,13.65-11.38,15.28h0c8.75,1.82,13.46,6.73,13.46,14.47,0,15.62-13.8,18.92-25.58,18.92h-27.87V.81Zm17.44,25.92h4.85c5.72,0,11.65-1.41,11.65-6.73s-5.59-6.73-11.44-6.73h-5.05v13.46Zm0,26.93h5.12c6.4,0,13.06-.94,13.06-7.61s-6.73-7.74-12.86-7.74h-5.32v15.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 296.39,
    y: 27.46,
    width: 82.87,
    height: 12.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m294.76,1.06v64.74h86.13V1.06h-86.13Zm3.26,51.18V15.01h79.67v37.23h-79.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 260.62,
    y: 18.04,
    width: 20.73,
    height: 15.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 198.35,
    y: 33.43,
    width: 20.73,
    height: 15.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 219.15,
    y: 18.04,
    width: 20.73,
    height: 15.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 239.89,
    y: 33.43,
    width: 20.73,
    height: 15.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m197.18.96v65.2h85.8V.96h-85.8Zm3.26,17.02h19.1V4.22h20.67v13.76h20.73V4.22h19.1v44.66h-19.43v13.82h-20.73v-13.82h-20.73v13.82h-19.04l.33-44.73Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "456.03 33.46 478.26 1.06 390.63 1.06 390.63 65.8 478.26 65.8 456.03 33.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 80.92,
    width: 478.26,
    height: 5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.84,117.2l.33-3.18c1.4.76,2.74,1.14,4.02,1.14.82,0,1.54-.2,2.16-.61.62-.41.93-1,.93-1.79s-.26-1.36-.79-1.7c-.52-.34-1.48-.8-2.85-1.39-1.38-.59-2.41-1.25-3.1-1.99-.69-.73-1.03-1.78-1.03-3.13,0-1.13.29-2.08.86-2.84.58-.76,1.34-1.31,2.29-1.67s1.98-.54,3.1-.54c1.5,0,2.91.23,4.24.7l-.3,2.92c-1.29-.59-2.51-.88-3.67-.88-.76,0-1.43.17-1.99.51s-.85.88-.85,1.62.21,1.18.64,1.44c.42.26,1.39.72,2.89,1.38,1.5.66,2.61,1.37,3.32,2.12.71.75,1.06,1.8,1.06,3.15,0,.96-.18,1.79-.53,2.49-.36.7-.85,1.28-1.47,1.73s-1.35.79-2.16,1.01c-.81.22-1.67.32-2.58.32-1.44,0-2.94-.27-4.5-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.84,117.6h-3.9l-1.54-4.02h-7.33l-1.52,4.02h-3.7l6.91-17.73h3.98l7.09,17.73Zm-6.54-6.94l-2.28-6.27c-.05-.14-.17-.53-.35-1.17-.07.27-.14.54-.21.81-.07.27-.13.49-.18.66l-2.13,5.97h5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.03,109.92v7.68h-3.62v-17.73h9.85v2.92h-6.26v4.21h6.01v2.92h-5.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.31,114.71v2.89h-10.6v-17.73h10.5v2.92h-6.92v4.28h6.33v2.89h-6.33v4.74h7.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m73.95,117.6h-3.58v-14.81h-5.06v-2.92h13.75v2.92h-5.1v14.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.87,117.6h-3.58v-7.07l-6.5-10.66h4.18l3.81,6.62c.14.23.27.51.4.82.09-.22.21-.48.36-.79l3.9-6.65h3.83l-6.4,10.55v7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m125.96,108.85c0,1.77-.34,3.34-1.03,4.74-.69,1.39-1.69,2.48-2.99,3.25-1.31.77-2.85,1.16-4.62,1.16s-3.4-.39-4.71-1.17c-1.31-.78-2.31-1.87-2.98-3.28s-1.01-3.02-1.01-4.83.34-3.42,1.01-4.82c.68-1.39,1.67-2.48,2.98-3.25s2.88-1.16,4.71-1.16c1.38,0,2.62.23,3.71.69s2,1.11,2.73,1.95c.73.84,1.28,1.83,1.65,2.96s.56,2.39.56,3.76Zm-3.8-.08c0-.77-.1-1.54-.29-2.31-.19-.77-.49-1.48-.89-2.12-.4-.64-.91-1.15-1.52-1.54-.61-.38-1.34-.58-2.17-.58-1.09,0-2,.32-2.73.97-.73.65-1.27,1.48-1.62,2.49-.35,1.01-.52,2.04-.52,3.08s.17,2.07.52,3.07c.35,1,.89,1.82,1.63,2.46.74.64,1.65.96,2.75.96.81,0,1.53-.19,2.15-.57s1.12-.89,1.52-1.53c.39-.64.69-1.34.88-2.1.19-.76.29-1.52.29-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m134.21,109.92v7.68h-3.62v-17.73h9.85v2.92h-6.26v4.21h6.01v2.92h-5.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m163.99,114.71v2.89h-10.5v-17.73h3.58v14.83h6.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m171.55,117.6h-3.58v-17.73h3.58v17.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m180.82,109.92v7.68h-3.62v-17.73h9.85v2.92h-6.26v4.21h6.01v2.92h-5.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m202.1,114.71v2.89h-10.6v-17.73h10.5v2.92h-6.92v4.28h6.33v2.89h-6.33v4.74h7.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m231.73,117.6h-3.9l-1.54-4.02h-7.33l-1.52,4.02h-3.7l6.91-17.73h3.98l7.09,17.73Zm-6.54-6.94l-2.28-6.27c-.05-.14-.17-.53-.35-1.17-.07.27-.14.54-.21.81-.07.27-.13.49-.18.66l-2.13,5.97h5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m249.91,117.6h-4.31l-5.81-10.71c-.37-.67-.86-1.72-1.47-3.14.27,1.84.4,3.37.4,4.57v9.28h-3.4v-17.73h4.22l5.96,10.73c.21.38.34.65.41.82.06.16.19.48.37.93.18.46.37.92.56,1.39-.22-1.24-.32-2.68-.32-4.33v-9.54h3.4v17.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m255.39,117.6v-17.73h4.04c1.1,0,2.08.03,2.95.1s1.73.23,2.6.48,1.65.62,2.35,1.12c.59.4,1.09.87,1.51,1.42.42.54.74,1.11.98,1.71.24.59.42,1.24.53,1.95s.18,1.42.18,2.13c0,1.49-.26,2.86-.77,4.11-.51,1.25-1.33,2.29-2.45,3.09-.59.43-1.25.77-2,1.01s-1.51.41-2.3.49c-.79.08-1.61.12-2.48.12h-5.13Zm3.58-2.74c.2,0,.36,0,.49,0,.13,0,.27.01.42.02,1.05,0,1.99-.13,2.82-.38.83-.25,1.54-.64,2.13-1.16.59-.51,1.05-1.16,1.37-1.95.32-.78.48-1.7.48-2.76s-.23-2.05-.69-2.98c-.46-.93-1.12-1.65-1.97-2.14-.35-.22-.73-.38-1.12-.5-.39-.12-.81-.2-1.25-.25s-.92-.09-1.45-.1c-.53-.02-.94-.03-1.23-.03v12.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m296.55,114.02l.13,3.13c-1.47.39-2.82.58-4.04.58-1.38,0-2.67-.18-3.84-.54s-2.21-.92-3.11-1.67-1.58-1.68-2.06-2.78c-.48-1.11-.72-2.38-.72-3.83s.22-2.74.65-3.88c.43-1.14,1.06-2.11,1.89-2.9.83-.79,1.82-1.39,2.98-1.79,1.16-.4,2.46-.6,3.89-.6,1.28,0,2.71.25,4.28.77l-.29,3.04c-1.17-.64-2.44-.96-3.8-.96-1.16,0-2.18.25-3.06.75-.88.5-1.56,1.19-2.03,2.08-.47.89-.71,1.92-.71,3.08s.25,2.28.75,3.25c.5.96,1.2,1.7,2.12,2.23.92.53,1.99.79,3.22.79s2.42-.25,3.75-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m316.75,117.6h-3.9l-1.54-4.02h-7.33l-1.52,4.02h-3.7l6.91-17.73h3.98l7.09,17.73Zm-6.54-6.94l-2.28-6.27c-.05-.14-.17-.53-.35-1.17-.07.27-.14.54-.21.81-.07.27-.13.49-.18.66l-2.13,5.97h5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m323.94,117.6h-3.62v-17.73h5.82c1.17,0,2.23.13,3.19.38.96.25,1.73.73,2.32,1.42.59.69.88,1.65.88,2.88,0,1.13-.32,2.07-.96,2.81-.64.74-1.52,1.2-2.63,1.37.58.22,1.01.53,1.3.95.29.42.58,1,.88,1.74l2.56,6.19h-3.98l-1.95-5.02c-.27-.73-.55-1.25-.84-1.56-.29-.32-.66-.52-1.1-.62s-1.06-.15-1.86-.15v7.36Zm-.03-10.1h1.6c.93,0,1.69-.2,2.29-.58.6-.39.9-1.01.9-1.87,0-1.61-.96-2.41-2.89-2.41h-1.9v4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m351.97,107.28v9.53c-1.74.61-3.64.92-5.71.92-1.47,0-2.8-.18-4-.55-1.19-.37-2.22-.93-3.07-1.67-.85-.75-1.51-1.7-1.96-2.84-.45-1.15-.68-2.47-.68-3.96s.25-2.79.77-3.93,1.23-2.08,2.15-2.83c.93-.75,2-1.3,3.23-1.66,1.23-.36,2.57-.54,4.01-.54,1.65,0,3.25.24,4.78.71l-.23,3.14c-1.5-.67-3.05-1.01-4.66-1.01-1.23,0-2.31.23-3.26.7-.94.47-1.68,1.15-2.2,2.05-.52.9-.79,1.98-.79,3.23,0,.87.13,1.7.4,2.47s.66,1.45,1.19,2.02c.52.58,1.15,1.03,1.89,1.35.74.32,1.56.48,2.48.48.75,0,1.51-.13,2.26-.38v-4.31h-3.78v-2.92h7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m373.67,108.85c0,1.77-.34,3.34-1.03,4.74-.69,1.39-1.69,2.48-2.99,3.25-1.31.77-2.85,1.16-4.62,1.16s-3.4-.39-4.71-1.17c-1.31-.78-2.31-1.87-2.98-3.28s-1.01-3.02-1.01-4.83.34-3.42,1.01-4.82c.68-1.39,1.67-2.48,2.98-3.25s2.88-1.16,4.71-1.16c1.38,0,2.62.23,3.71.69s2,1.11,2.73,1.95c.73.84,1.28,1.83,1.65,2.96s.56,2.39.56,3.76Zm-3.8-.08c0-.77-.1-1.54-.29-2.31-.19-.77-.49-1.48-.89-2.12-.4-.64-.91-1.15-1.52-1.54-.61-.38-1.34-.58-2.17-.58-1.09,0-2,.32-2.73.97-.73.65-1.27,1.48-1.62,2.49-.35,1.01-.52,2.04-.52,3.08s.17,2.07.52,3.07c.35,1,.89,1.82,1.63,2.46.74.64,1.65.96,2.75.96.81,0,1.53-.19,2.15-.57s1.12-.89,1.52-1.53c.39-.64.69-1.34.88-2.1.19-.76.29-1.52.29-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m403.06,117.6h-3.9l-1.54-4.02h-7.33l-1.52,4.02h-3.7l6.91-17.73h3.98l7.09,17.73Zm-6.54-6.94l-2.28-6.27c-.05-.14-.17-.53-.35-1.17-.07.27-.14.54-.21.81-.07.27-.13.49-.18.66l-2.13,5.97h5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m413.39,117.6h-3.58v-14.81h-5.06v-2.92h13.75v2.92h-5.1v14.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m430.44,117.2l.33-3.18c1.4.76,2.74,1.14,4.02,1.14.82,0,1.54-.2,2.16-.61.62-.41.93-1,.93-1.79s-.26-1.36-.79-1.7c-.52-.34-1.48-.8-2.85-1.39-1.38-.59-2.41-1.25-3.1-1.99-.69-.73-1.03-1.78-1.03-3.13,0-1.13.29-2.08.86-2.84.58-.76,1.34-1.31,2.29-1.67s1.98-.54,3.1-.54c1.5,0,2.91.23,4.24.7l-.3,2.92c-1.29-.59-2.51-.88-3.67-.88-.76,0-1.43.17-1.99.51s-.85.88-.85,1.62.21,1.18.64,1.44c.42.26,1.39.72,2.89,1.38,1.5.66,2.61,1.37,3.32,2.12.71.75,1.06,1.8,1.06,3.15,0,.96-.18,1.79-.53,2.49-.36.7-.85,1.28-1.47,1.73s-1.35.79-2.16,1.01c-.81.22-1.67.32-2.58.32-1.44,0-2.94-.27-4.5-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m456.91,114.71v2.89h-10.6v-17.73h10.5v2.92h-6.92v4.28h6.33v2.89h-6.33v4.74h7.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m477.94,117.6h-3.9l-1.54-4.02h-7.33l-1.52,4.02h-3.7l6.91-17.73h3.98l7.09,17.73Zm-6.54-6.94l-2.28-6.27c-.05-.14-.17-.53-.35-1.17-.07.27-.14.54-.21.81-.07.27-.13.49-.18.66l-2.13,5.97h5.15Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcbSolacDark);
export default __webpack_public_path__ + "static/media/ncb-solac-dark.af85995f51406392ff9a5d3a8f9c718b.svg";
export { ForwardRef as ReactComponent };